<template>
    <a-form :label-col="labelCol" :label-align="labelAlign" :layout="layout" :validate-on-rule-change="false"
        :model="formDataModel" style="padding: 5px;">
        <template v-for="(widget, index) in widgetList" :key="widget.id">
            <component :is="getWidgetName(widget)" :widget="widget" :widgetList="widgetList" :indexOfParentList="index"
                :isDesign="false" :formData="formDataModel">
            </component>
        </template>
    </a-form>
</template>

<script>
export default {
    name: "FormRender",
};
</script>
<script setup>
import ContainerComponents from "../form-design/form-widget/container/index.js";
import FieldComponents from "../form-design/form-widget/form-item/index.js";
import { ref, toRefs, computed, provide, defineExpose, onMounted } from 'vue';

const props = defineProps({
    formJsonObj: Object,
    formDataModel: Object,
})
const { formJsonObj, formDataModel } = toRefs(props)
const widgetList = computed(() => formJsonObj.value.widgetList)
const instanceList = ref({})

const labelCol = computed(() => { return { style: { width: (formJsonObj.value.formConfig.labelWidth || "80") + 'px' } } })
const labelAlign = computed(() => formJsonObj.value.formConfig.labelAlign || "left")
const layout = computed(() => formJsonObj.value.formConfig.layout || "horizontal")


// const handleOnMounted = () => {
//     if (!!formJsonObj.value.formConfig.onFormMounted) {
//         let customFunc = new Function(formJsonObj.value.formConfig.onFormMounted);
//         customFunc();
//     }
// };
// onMounted(() => handleOnMounted());

const getWidgetName = (widget) => {
    let obj = { ...FieldComponents, ...ContainerComponents }
    return obj[widget.type + "-widget"]
}

const getInstanceList = () => {
    return instanceList.value
}
provide("instance", {
    getInstanceList,
});
const setDisabled = () => {
    Object.values(instanceList.value).forEach(item => item.setDisabled())
}
const destoryInstanceList = () => {
    instanceList.value = {}
}
defineExpose({ destoryInstanceList, setDisabled })
</script>